import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface Toast {
  id: string
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
  duration: number
}

interface UIState {
  sidebarOpen: boolean
  sidebarExpanded: boolean
  guardianViewActive: boolean
  toasts: Toast[]
  openSidebar: () => void
  closeSidebar: () => void
  toggleExpanded: () => void
  setGuardianView: (active: boolean) => void
  showToast: (message: string, type?: Toast['type'], duration?: number) => void
  dismissToast: (id: string) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarOpen: false,
      sidebarExpanded: false,
      guardianViewActive: false,
      toasts: [],
      openSidebar: () => set({ sidebarOpen: true }),
      closeSidebar: () => set({ sidebarOpen: false }),
      toggleExpanded: () => set((s) => ({ sidebarExpanded: !s.sidebarExpanded })),
      setGuardianView: (active) => set({ guardianViewActive: active }),
      showToast(message, type = 'info', duration = 3500) {
        const id = crypto.randomUUID()
        set((s) => ({ toasts: [...s.toasts, { id, message, type, duration }] }))
        setTimeout(() => {
          set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
        }, duration)
      },
      dismissToast(id) {
        set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
      },
    }),
    {
      name: 'beacon-ui',
      partialize: (s) => ({ sidebarExpanded: s.sidebarExpanded, guardianViewActive: s.guardianViewActive }),
    }
  )
)
